import { render } from "./App.vue?vue&type=template&id=cbf775fe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cbf775fe&lang=css"

import exportComponent from "/hpgdata/jenkins/workspace/medicollege_front_prod/front-medicollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__